/**
 * Firebase Collection References
 * 
 * Centralized collection names for consistency across the application.
 * This file defines all Firestore collection paths used in the app.
 */

// Root-level collections
export const ROOT_COLLECTIONS = {
  USERS: 'users',
  ENVIRONMENTS: 'environments',
} as const;

// Environment-scoped collections
// These collections exist under environments/{envId}/
export const ENV_COLLECTIONS = {
  PRODUCTS: 'products',
  JOBS: 'jobs',
  JOB_SHEETS: 'jobsheets',
  OPERATORS: 'operators',
  INVOICES: 'invoices',
  MACHINE_TYPES: 'machinetypes',
  DESCRIPTIONS: 'descriptions',
  ACCOUNTS: 'accounts',
  COMPANIES: 'companies',
  XERO_TOKENS: 'xeroTokens',
  XERO_ITEMS: 'xeroItems',
  CASHBOOK_COMPANIES: 'cashbook_companies',
  CHART_OF_ACCOUNTS: 'chartOfAccounts',
} as const;

// Helper functions to build collection paths
export const getEnvCollection = (envId: string, collection: keyof typeof ENV_COLLECTIONS): string => {
  return `${ROOT_COLLECTIONS.ENVIRONMENTS}/${envId}/${ENV_COLLECTIONS[collection]}`;
};

export const getRootCollection = (collection: keyof typeof ROOT_COLLECTIONS): string => {
  return ROOT_COLLECTIONS[collection];
};

// Storage paths for Firebase Storage
export const STORAGE_PATHS = {
  JOB_SHEET_IMAGES: (envId: string, jobSheetId: string, fileName: string) => 
    `${ROOT_COLLECTIONS.ENVIRONMENTS}/${envId}/JobSheets/${jobSheetId}/${fileName}`,
} as const;

// Type definitions for better TypeScript support
export type RootCollection = keyof typeof ROOT_COLLECTIONS;
export type EnvCollection = keyof typeof ENV_COLLECTIONS;
